.nav {
  width: 100vw;
  padding: 0.7rem 2.6rem 0.7rem 1.7rem;
  position: sticky;
  top: 0;
  display: none;
  justify-content: space-between;
  backdrop-filter: blur(7px);
  z-index: 50;
}

.navLogo {
  font-family: "Cairo Play Variable", sans-serif;
  font-size: 1.4rem;
  font-weight: 700;
}

.navRoutesAndTheme {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.routes a {
  margin-left: 1.5rem;
  font-weight: 600;
}

.theme {
  position: relative;
}

.themeNavBtn {
  display: flex;
  border-radius: 50%;
  border: none;
  margin-left: 1.5rem;
  padding: 7px;
  font-size: 1.5rem;
  background-color: transparent;
}

.themeModal {
  position: absolute;
  right: 0;
  margin-top: 7px;
  padding: 5px;
  width: 120px;
  border-radius: 5px;
}

.themeOption {
  display: flex;
  align-items: center;
  padding: 5px 13px;
  border: none;
  border-radius: 3px;
  width: 100%;
  background-color: transparent;
}

.themeOption span {
  margin-left: 9px;
  font-size: var(--small-text);
}

/* Desktop */
@media (min-width: 1024px) {
  .nav {
    display: flex;
  }
}

/* Color scheme when device's theme is light mode */
@media (prefers-color-scheme: light) {
  .nav {
    background-color: rgba(255, 255, 255, 0.91);
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  }
  .nav a,
  .themeNavBtn {
    color: var(--primary-color);
  }
  .themeModal {
    background-color: var(--secondary-color);
    box-shadow: rgba(14, 30, 37, 0.12) 0px 2px 4px 0px,
      rgba(14, 30, 37, 0.32) 0px 2px 16px 0px;
  }
  /* Enable hover only on non-touch devices */
  @media (hover: hover) and (pointer: fine) {
    .themeNavBtn:hover {
      background-color: rgba(0, 0, 0, 0.1);
    }
  }
}

/* Color scheme when device's theme is dark mode */
@media (prefers-color-scheme: dark) {
  .nav {
    background-color: rgba(17, 17, 17, 0.91);
    box-shadow: 0 1px 2px 0 rgba(255, 255, 255, 0.14);
  }
  .nav a,
  .themeNavBtn {
    color: var(--secondary-color);
  }
  .themeModal {
    background-color: var(--primary-color);
    box-shadow: rgba(241, 225, 218, 0.12) 0px 2px 4px 0px,
      rgba(241, 225, 218, 0.32) 0px 2px 16px 0px;
  }
  /* Enable hover only on non-touch devices */
  @media (hover: hover) and (pointer: fine) {
    .themeNavBtn:hover {
      background-color: rgba(255, 255, 255, 0.1);
    }
  }
}

/* Enable hover only on non-touch devices */
@media (hover: hover) and (pointer: fine) {
  .routes a:hover {
    color: var(--accent-color);
  }
  .themeNavBtn:hover {
    cursor: pointer;
  }
  .themeOption:hover {
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.1);
  }
}
